/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TimePickerPopup/view.blocks to change it.
import React from 'react'
import TimePicker from 'DesignSystem/TimePicker/index'
import styles from './view.module.css'
import useIsBefore from 'Simple/hooks/useIsBefore'
import viewPath from './viewPath.js'
import { animated, useSpring } from "@react-spring/web"



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function TimePickerPopup({
  children,
  viewPath = "/DesignSystem/Calendar/TimePickerPopup",
  onClickTime,
  slotsAvailability,
  isSelected,
  parentViewPath
  
}) {
  let isBefore = useIsBefore()
let animatedVertical1 = useSpring({
"config": {
tension: 180,
friction: 12,
},
"from": {"top": "50px"},
"to": {"top": isBefore ? "45px" : "50px"},
})
  return (<React.Fragment
>
<animated.div
  data-testid="TimePickerPopup.Vertical"
  data-view-path={viewPath}
 style={{"--t-2-ZMtLDs": animatedVertical1.top,'--o-1-ZMtLDs': isBefore ? 0 : 1}}
 className={`views-block ${styles.Vertical}`}
>
<TimePicker
  viewPath={`${viewPath}/TimePicker`}
 onClick={onClickTime}
 from={slotsAvailability}
 isSelected={isSelected}
 parentViewPath={parentViewPath}
/>
</animated.div>
{children}
</React.Fragment>)
}